/** Low-stock threshold (matches product detail page). */
export const LOW_STOCK_THRESHOLD = 5;

/**
 * Normalize stock status from API-shaped products (quantity) or UI-shaped (stock string).
 * @param {object} product
 * @returns {'out-of-stock'|'low-stock'|'in-stock'}
 */
export function getStockStatusFromProduct(product) {
  if (!product) return 'in-stock';
  const s = product.stock;
  if (s === 'out-of-stock' || s === 'low-stock' || s === 'in-stock') return s;

  const q = Number(
    product.stockQuantity ?? product.quantity ?? (typeof s === 'number' ? s : NaN)
  );
  if (!Number.isFinite(q)) return 'in-stock';
  if (q <= 0) return 'out-of-stock';
  if (q <= LOW_STOCK_THRESHOLD) return 'low-stock';
  return 'in-stock';
}

export function getAvailableQuantity(product) {
  if (!product) return 0;
  const q = Number(
    product.stockQuantity ?? product.quantity ?? (typeof product.stock === 'number' ? product.stock : NaN)
  );
  return Number.isFinite(q) ? Math.max(0, q) : 0;
}
